import { Routes, Route } from "react-router-dom";
import { PaymentsPage } from "./pages/PaymentsPage";

export const PaymentsNavigation = () => {
  return (
    <Routes>
      <Route index element={<PaymentsPage />} />
    </Routes>
  );
};
